import { DepartmentCode } from 'types';

export const getDepartment = (departmentCode: DepartmentCode | '--') => {
  let departmentValue = departmentCode ?? '--';
  let departmentLabel = '--';
  switch (departmentValue) {
    case 'DEP1000001':
      departmentLabel = 'PO본부';
      break;
    case 'DEP1000002':
      departmentLabel = 'PD본부';
      break;
    case 'DEP1000003':
      departmentLabel = 'LRD본부';
      break;
    case 'DEP1000004':
      departmentLabel = '기술본부';
      break;
    case 'DEP1000005':
      departmentLabel = '컨설팅본부';
      break;
    case 'DEP1000006':
      departmentLabel = '신사업개발본부';
      break;
    case 'DEP1000007':
      departmentLabel = '재무전략실';
      break;
    case 'DEP1000008':
      departmentLabel = '경영지원실';
      break;
    case 'DEP1000009':
      departmentLabel = '마케팅팀';
      break;
    case 'DEP1000010':
      departmentLabel = '전략실';
      break;
    case 'DEP1000011':
      departmentLabel = '법무감사실';
      break;
    case 'DEP1000012':
      departmentLabel = '전사고문';
      break;
    case 'DEP1000013':
      departmentLabel = '마크애니 체인버스';
      break;
    default:
      departmentLabel = '--';
      break;
  }

  return departmentLabel;
};
